/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as ForbiddenRouteImport } from './routes/forbidden'
import { Route as AuthDeviceRouteImport } from './routes/_auth/device'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthOneTimeTokenRouteImport } from './routes/_auth/one-time-token'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth/verify-email'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedInboxRouteImport } from './routes/_authenticated/inbox'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedSetPasswordRouteImport } from './routes/_authenticated/set-password'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedTenantsRouteImport } from './routes/_authenticated/tenants'
import { Route as LegalDocumentKeyRouteImport } from './routes/legal/$documentKey'
import { Route as AuthenticatedOperationsAnnouncementsRouteImport } from './routes/_authenticated/operations/announcements'
import { Route as AuthenticatedOperationsCertificationsRouteImport } from './routes/_authenticated/operations/certifications'
import { Route as AuthenticatedOperationsCompanyTypesRouteImport } from './routes/_authenticated/operations/company-types'
import { Route as AuthenticatedOperationsConnectionsRouteImport } from './routes/_authenticated/operations/connections'
import { Route as AuthenticatedOperationsCountryRegionsRouteImport } from './routes/_authenticated/operations/country-regions'
import { Route as AuthenticatedOperationsDailyOperationsRouteImport } from './routes/_authenticated/operations/daily-operations'
import { Route as AuthenticatedOperationsFeedbackRouteImport } from './routes/_authenticated/operations/feedback'
import { Route as AuthenticatedOperationsImportsRouteImport } from './routes/_authenticated/operations/imports'
import { Route as AuthenticatedOperationsIndustriesRouteImport } from './routes/_authenticated/operations/industries'
import { Route as AuthenticatedOperationsInvitationCodesRouteImport } from './routes/_authenticated/operations/invitation-codes'
import { Route as AuthenticatedOperationsMembershipsRouteImport } from './routes/_authenticated/operations/memberships'
import { Route as AuthenticatedOperationsOpportunitiesRouteImport } from './routes/_authenticated/operations/opportunities'
import { Route as AuthenticatedSystemConfigsRouteImport } from './routes/_authenticated/system/configs'
import { Route as AuthenticatedSystemDepartmentsRouteImport } from './routes/_authenticated/system/departments'
import { Route as AuthenticatedSystemFilesRouteImport } from './routes/_authenticated/system/files'
import { Route as AuthenticatedSystemLegalRouteImport } from './routes/_authenticated/system/legal'
import { Route as AuthenticatedSystemLogsRouteImport } from './routes/_authenticated/system/logs'
import { Route as AuthenticatedSystemMenusRouteImport } from './routes/_authenticated/system/menus'
import { Route as AuthenticatedSystemPositionsRouteImport } from './routes/_authenticated/system/positions'
import { Route as AuthenticatedSystemRolesRouteImport } from './routes/_authenticated/system/roles'
import { Route as AuthenticatedSystemSmsConfigsRouteImport } from './routes/_authenticated/system/sms-configs'
import { Route as AuthenticatedSystemStorageDisksRouteImport } from './routes/_authenticated/system/storage-disks'
import { Route as AuthenticatedSystemTasksRouteImport } from './routes/_authenticated/system/tasks'
import { Route as AuthenticatedOperationsEnterprisesIndexRouteImport } from './routes/_authenticated/operations/enterprises/index'
import { Route as AuthenticatedOperationsEnterprisesEnterpriseIdRouteImport } from './routes/_authenticated/operations/enterprises/$enterpriseId'
import { Route as AuthenticatedSystemDictsIndexRouteImport } from './routes/_authenticated/system/dicts/index'
import { Route as AuthenticatedSystemDictsTypeIdRouteImport } from './routes/_authenticated/system/dicts/$typeId'
import { Route as AuthenticatedSystemEnterprisesIndexRouteImport } from './routes/_authenticated/system/enterprises/index'
import { Route as AuthenticatedSystemEnterprisesEnterpriseIdRouteImport } from './routes/_authenticated/system/enterprises/$enterpriseId'
import { Route as AuthenticatedSystemMonitorRedisRouteImport } from './routes/_authenticated/system/monitor/redis'
import { Route as AuthenticatedSystemMonitorServiceRouteImport } from './routes/_authenticated/system/monitor/service'
import { Route as AuthenticatedSystemMonitorSessionsRouteImport } from './routes/_authenticated/system/monitor/sessions'
import { Route as AuthenticatedSystemUsersIndexRouteImport } from './routes/_authenticated/system/users/index'
import { Route as AuthenticatedSystemUsersUserIdRouteImport } from './routes/_authenticated/system/users/$userId'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const ForbiddenRoute = ForbiddenRouteImport.update({
  id: '/forbidden',
  path: '/forbidden',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDeviceRoute = AuthDeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthOneTimeTokenRoute = AuthOneTimeTokenRouteImport.update({
  id: '/one-time-token',
  path: '/one-time-token',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedInboxRoute = AuthenticatedInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSetPasswordRoute =
  AuthenticatedSetPasswordRouteImport.update({
    id: '/set-password',
    path: '/set-password',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedTenantsRoute = AuthenticatedTenantsRouteImport.update({
  id: '/tenants',
  path: '/tenants',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const LegalDocumentKeyRoute = LegalDocumentKeyRouteImport.update({
  id: '/legal/$documentKey',
  path: '/legal/$documentKey',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedOperationsAnnouncementsRoute =
  AuthenticatedOperationsAnnouncementsRouteImport.update({
    id: '/operations/announcements',
    path: '/operations/announcements',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsCertificationsRoute =
  AuthenticatedOperationsCertificationsRouteImport.update({
    id: '/operations/certifications',
    path: '/operations/certifications',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsCompanyTypesRoute =
  AuthenticatedOperationsCompanyTypesRouteImport.update({
    id: '/operations/company-types',
    path: '/operations/company-types',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsConnectionsRoute =
  AuthenticatedOperationsConnectionsRouteImport.update({
    id: '/operations/connections',
    path: '/operations/connections',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsCountryRegionsRoute =
  AuthenticatedOperationsCountryRegionsRouteImport.update({
    id: '/operations/country-regions',
    path: '/operations/country-regions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsDailyOperationsRoute =
  AuthenticatedOperationsDailyOperationsRouteImport.update({
    id: '/operations/daily-operations',
    path: '/operations/daily-operations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsFeedbackRoute =
  AuthenticatedOperationsFeedbackRouteImport.update({
    id: '/operations/feedback',
    path: '/operations/feedback',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsImportsRoute =
  AuthenticatedOperationsImportsRouteImport.update({
    id: '/operations/imports',
    path: '/operations/imports',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsIndustriesRoute =
  AuthenticatedOperationsIndustriesRouteImport.update({
    id: '/operations/industries',
    path: '/operations/industries',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsInvitationCodesRoute =
  AuthenticatedOperationsInvitationCodesRouteImport.update({
    id: '/operations/invitation-codes',
    path: '/operations/invitation-codes',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsMembershipsRoute =
  AuthenticatedOperationsMembershipsRouteImport.update({
    id: '/operations/memberships',
    path: '/operations/memberships',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsOpportunitiesRoute =
  AuthenticatedOperationsOpportunitiesRouteImport.update({
    id: '/operations/opportunities',
    path: '/operations/opportunities',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemConfigsRoute =
  AuthenticatedSystemConfigsRouteImport.update({
    id: '/system/configs',
    path: '/system/configs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemDepartmentsRoute =
  AuthenticatedSystemDepartmentsRouteImport.update({
    id: '/system/departments',
    path: '/system/departments',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemFilesRoute =
  AuthenticatedSystemFilesRouteImport.update({
    id: '/system/files',
    path: '/system/files',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemLegalRoute =
  AuthenticatedSystemLegalRouteImport.update({
    id: '/system/legal',
    path: '/system/legal',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemLogsRoute = AuthenticatedSystemLogsRouteImport.update({
  id: '/system/logs',
  path: '/system/logs',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSystemMenusRoute =
  AuthenticatedSystemMenusRouteImport.update({
    id: '/system/menus',
    path: '/system/menus',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemPositionsRoute =
  AuthenticatedSystemPositionsRouteImport.update({
    id: '/system/positions',
    path: '/system/positions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemRolesRoute =
  AuthenticatedSystemRolesRouteImport.update({
    id: '/system/roles',
    path: '/system/roles',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemSmsConfigsRoute =
  AuthenticatedSystemSmsConfigsRouteImport.update({
    id: '/system/sms-configs',
    path: '/system/sms-configs',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemStorageDisksRoute =
  AuthenticatedSystemStorageDisksRouteImport.update({
    id: '/system/storage-disks',
    path: '/system/storage-disks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemTasksRoute =
  AuthenticatedSystemTasksRouteImport.update({
    id: '/system/tasks',
    path: '/system/tasks',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsEnterprisesIndexRoute =
  AuthenticatedOperationsEnterprisesIndexRouteImport.update({
    id: '/operations/enterprises/',
    path: '/operations/enterprises/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedOperationsEnterprisesEnterpriseIdRoute =
  AuthenticatedOperationsEnterprisesEnterpriseIdRouteImport.update({
    id: '/operations/enterprises/$enterpriseId',
    path: '/operations/enterprises/$enterpriseId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemDictsIndexRoute =
  AuthenticatedSystemDictsIndexRouteImport.update({
    id: '/system/dicts/',
    path: '/system/dicts/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemDictsTypeIdRoute =
  AuthenticatedSystemDictsTypeIdRouteImport.update({
    id: '/system/dicts/$typeId',
    path: '/system/dicts/$typeId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemEnterprisesIndexRoute =
  AuthenticatedSystemEnterprisesIndexRouteImport.update({
    id: '/system/enterprises/',
    path: '/system/enterprises/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemEnterprisesEnterpriseIdRoute =
  AuthenticatedSystemEnterprisesEnterpriseIdRouteImport.update({
    id: '/system/enterprises/$enterpriseId',
    path: '/system/enterprises/$enterpriseId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemMonitorRedisRoute =
  AuthenticatedSystemMonitorRedisRouteImport.update({
    id: '/system/monitor/redis',
    path: '/system/monitor/redis',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemMonitorServiceRoute =
  AuthenticatedSystemMonitorServiceRouteImport.update({
    id: '/system/monitor/service',
    path: '/system/monitor/service',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemMonitorSessionsRoute =
  AuthenticatedSystemMonitorSessionsRouteImport.update({
    id: '/system/monitor/sessions',
    path: '/system/monitor/sessions',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemUsersIndexRoute =
  AuthenticatedSystemUsersIndexRouteImport.update({
    id: '/system/users/',
    path: '/system/users/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSystemUsersUserIdRoute =
  AuthenticatedSystemUsersUserIdRouteImport.update({
    id: '/system/users/$userId',
    path: '/system/users/$userId',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/device': typeof AuthDeviceRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/one-time-token': typeof AuthOneTimeTokenRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/set-password': typeof AuthenticatedSetPasswordRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/tenants': typeof AuthenticatedTenantsRoute
  '/legal/$documentKey': typeof LegalDocumentKeyRoute
  '/operations/announcements': typeof AuthenticatedOperationsAnnouncementsRoute
  '/operations/certifications': typeof AuthenticatedOperationsCertificationsRoute
  '/operations/company-types': typeof AuthenticatedOperationsCompanyTypesRoute
  '/operations/connections': typeof AuthenticatedOperationsConnectionsRoute
  '/operations/country-regions': typeof AuthenticatedOperationsCountryRegionsRoute
  '/operations/daily-operations': typeof AuthenticatedOperationsDailyOperationsRoute
  '/operations/feedback': typeof AuthenticatedOperationsFeedbackRoute
  '/operations/imports': typeof AuthenticatedOperationsImportsRoute
  '/operations/industries': typeof AuthenticatedOperationsIndustriesRoute
  '/operations/invitation-codes': typeof AuthenticatedOperationsInvitationCodesRoute
  '/operations/memberships': typeof AuthenticatedOperationsMembershipsRoute
  '/operations/opportunities': typeof AuthenticatedOperationsOpportunitiesRoute
  '/system/configs': typeof AuthenticatedSystemConfigsRoute
  '/system/departments': typeof AuthenticatedSystemDepartmentsRoute
  '/system/files': typeof AuthenticatedSystemFilesRoute
  '/system/legal': typeof AuthenticatedSystemLegalRoute
  '/system/logs': typeof AuthenticatedSystemLogsRoute
  '/system/menus': typeof AuthenticatedSystemMenusRoute
  '/system/positions': typeof AuthenticatedSystemPositionsRoute
  '/system/roles': typeof AuthenticatedSystemRolesRoute
  '/system/sms-configs': typeof AuthenticatedSystemSmsConfigsRoute
  '/system/storage-disks': typeof AuthenticatedSystemStorageDisksRoute
  '/system/tasks': typeof AuthenticatedSystemTasksRoute
  '/operations/enterprises/$enterpriseId': typeof AuthenticatedOperationsEnterprisesEnterpriseIdRoute
  '/system/dicts/$typeId': typeof AuthenticatedSystemDictsTypeIdRoute
  '/system/enterprises/$enterpriseId': typeof AuthenticatedSystemEnterprisesEnterpriseIdRoute
  '/system/monitor/redis': typeof AuthenticatedSystemMonitorRedisRoute
  '/system/monitor/service': typeof AuthenticatedSystemMonitorServiceRoute
  '/system/monitor/sessions': typeof AuthenticatedSystemMonitorSessionsRoute
  '/system/users/$userId': typeof AuthenticatedSystemUsersUserIdRoute
  '/operations/enterprises/': typeof AuthenticatedOperationsEnterprisesIndexRoute
  '/system/dicts/': typeof AuthenticatedSystemDictsIndexRoute
  '/system/enterprises/': typeof AuthenticatedSystemEnterprisesIndexRoute
  '/system/users/': typeof AuthenticatedSystemUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthenticatedIndexRoute
  '/forbidden': typeof ForbiddenRoute
  '/device': typeof AuthDeviceRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/one-time-token': typeof AuthOneTimeTokenRoute
  '/register': typeof AuthRegisterRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/inbox': typeof AuthenticatedInboxRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/set-password': typeof AuthenticatedSetPasswordRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/tenants': typeof AuthenticatedTenantsRoute
  '/legal/$documentKey': typeof LegalDocumentKeyRoute
  '/operations/announcements': typeof AuthenticatedOperationsAnnouncementsRoute
  '/operations/certifications': typeof AuthenticatedOperationsCertificationsRoute
  '/operations/company-types': typeof AuthenticatedOperationsCompanyTypesRoute
  '/operations/connections': typeof AuthenticatedOperationsConnectionsRoute
  '/operations/country-regions': typeof AuthenticatedOperationsCountryRegionsRoute
  '/operations/daily-operations': typeof AuthenticatedOperationsDailyOperationsRoute
  '/operations/feedback': typeof AuthenticatedOperationsFeedbackRoute
  '/operations/imports': typeof AuthenticatedOperationsImportsRoute
  '/operations/industries': typeof AuthenticatedOperationsIndustriesRoute
  '/operations/invitation-codes': typeof AuthenticatedOperationsInvitationCodesRoute
  '/operations/memberships': typeof AuthenticatedOperationsMembershipsRoute
  '/operations/opportunities': typeof AuthenticatedOperationsOpportunitiesRoute
  '/system/configs': typeof AuthenticatedSystemConfigsRoute
  '/system/departments': typeof AuthenticatedSystemDepartmentsRoute
  '/system/files': typeof AuthenticatedSystemFilesRoute
  '/system/legal': typeof AuthenticatedSystemLegalRoute
  '/system/logs': typeof AuthenticatedSystemLogsRoute
  '/system/menus': typeof AuthenticatedSystemMenusRoute
  '/system/positions': typeof AuthenticatedSystemPositionsRoute
  '/system/roles': typeof AuthenticatedSystemRolesRoute
  '/system/sms-configs': typeof AuthenticatedSystemSmsConfigsRoute
  '/system/storage-disks': typeof AuthenticatedSystemStorageDisksRoute
  '/system/tasks': typeof AuthenticatedSystemTasksRoute
  '/operations/enterprises/$enterpriseId': typeof AuthenticatedOperationsEnterprisesEnterpriseIdRoute
  '/system/dicts/$typeId': typeof AuthenticatedSystemDictsTypeIdRoute
  '/system/enterprises/$enterpriseId': typeof AuthenticatedSystemEnterprisesEnterpriseIdRoute
  '/system/monitor/redis': typeof AuthenticatedSystemMonitorRedisRoute
  '/system/monitor/service': typeof AuthenticatedSystemMonitorServiceRoute
  '/system/monitor/sessions': typeof AuthenticatedSystemMonitorSessionsRoute
  '/system/users/$userId': typeof AuthenticatedSystemUsersUserIdRoute
  '/operations/enterprises': typeof AuthenticatedOperationsEnterprisesIndexRoute
  '/system/dicts': typeof AuthenticatedSystemDictsIndexRoute
  '/system/enterprises': typeof AuthenticatedSystemEnterprisesIndexRoute
  '/system/users': typeof AuthenticatedSystemUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteRouteWithChildren
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/forbidden': typeof ForbiddenRoute
  '/_auth/device': typeof AuthDeviceRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/one-time-token': typeof AuthOneTimeTokenRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/_authenticated/inbox': typeof AuthenticatedInboxRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/set-password': typeof AuthenticatedSetPasswordRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/tenants': typeof AuthenticatedTenantsRoute
  '/legal/$documentKey': typeof LegalDocumentKeyRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/operations/announcements': typeof AuthenticatedOperationsAnnouncementsRoute
  '/_authenticated/operations/certifications': typeof AuthenticatedOperationsCertificationsRoute
  '/_authenticated/operations/company-types': typeof AuthenticatedOperationsCompanyTypesRoute
  '/_authenticated/operations/connections': typeof AuthenticatedOperationsConnectionsRoute
  '/_authenticated/operations/country-regions': typeof AuthenticatedOperationsCountryRegionsRoute
  '/_authenticated/operations/daily-operations': typeof AuthenticatedOperationsDailyOperationsRoute
  '/_authenticated/operations/feedback': typeof AuthenticatedOperationsFeedbackRoute
  '/_authenticated/operations/imports': typeof AuthenticatedOperationsImportsRoute
  '/_authenticated/operations/industries': typeof AuthenticatedOperationsIndustriesRoute
  '/_authenticated/operations/invitation-codes': typeof AuthenticatedOperationsInvitationCodesRoute
  '/_authenticated/operations/memberships': typeof AuthenticatedOperationsMembershipsRoute
  '/_authenticated/operations/opportunities': typeof AuthenticatedOperationsOpportunitiesRoute
  '/_authenticated/system/configs': typeof AuthenticatedSystemConfigsRoute
  '/_authenticated/system/departments': typeof AuthenticatedSystemDepartmentsRoute
  '/_authenticated/system/files': typeof AuthenticatedSystemFilesRoute
  '/_authenticated/system/legal': typeof AuthenticatedSystemLegalRoute
  '/_authenticated/system/logs': typeof AuthenticatedSystemLogsRoute
  '/_authenticated/system/menus': typeof AuthenticatedSystemMenusRoute
  '/_authenticated/system/positions': typeof AuthenticatedSystemPositionsRoute
  '/_authenticated/system/roles': typeof AuthenticatedSystemRolesRoute
  '/_authenticated/system/sms-configs': typeof AuthenticatedSystemSmsConfigsRoute
  '/_authenticated/system/storage-disks': typeof AuthenticatedSystemStorageDisksRoute
  '/_authenticated/system/tasks': typeof AuthenticatedSystemTasksRoute
  '/_authenticated/operations/enterprises/$enterpriseId': typeof AuthenticatedOperationsEnterprisesEnterpriseIdRoute
  '/_authenticated/system/dicts/$typeId': typeof AuthenticatedSystemDictsTypeIdRoute
  '/_authenticated/system/enterprises/$enterpriseId': typeof AuthenticatedSystemEnterprisesEnterpriseIdRoute
  '/_authenticated/system/monitor/redis': typeof AuthenticatedSystemMonitorRedisRoute
  '/_authenticated/system/monitor/service': typeof AuthenticatedSystemMonitorServiceRoute
  '/_authenticated/system/monitor/sessions': typeof AuthenticatedSystemMonitorSessionsRoute
  '/_authenticated/system/users/$userId': typeof AuthenticatedSystemUsersUserIdRoute
  '/_authenticated/operations/enterprises/': typeof AuthenticatedOperationsEnterprisesIndexRoute
  '/_authenticated/system/dicts/': typeof AuthenticatedSystemDictsIndexRoute
  '/_authenticated/system/enterprises/': typeof AuthenticatedSystemEnterprisesIndexRoute
  '/_authenticated/system/users/': typeof AuthenticatedSystemUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forbidden'
    | '/device'
    | '/forgot-password'
    | '/login'
    | '/one-time-token'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/inbox'
    | '/profile'
    | '/set-password'
    | '/settings'
    | '/tenants'
    | '/legal/$documentKey'
    | '/operations/announcements'
    | '/operations/certifications'
    | '/operations/company-types'
    | '/operations/connections'
    | '/operations/country-regions'
    | '/operations/daily-operations'
    | '/operations/feedback'
    | '/operations/imports'
    | '/operations/industries'
    | '/operations/invitation-codes'
    | '/operations/memberships'
    | '/operations/opportunities'
    | '/system/configs'
    | '/system/departments'
    | '/system/files'
    | '/system/legal'
    | '/system/logs'
    | '/system/menus'
    | '/system/positions'
    | '/system/roles'
    | '/system/sms-configs'
    | '/system/storage-disks'
    | '/system/tasks'
    | '/operations/enterprises/$enterpriseId'
    | '/system/dicts/$typeId'
    | '/system/enterprises/$enterpriseId'
    | '/system/monitor/redis'
    | '/system/monitor/service'
    | '/system/monitor/sessions'
    | '/system/users/$userId'
    | '/operations/enterprises/'
    | '/system/dicts/'
    | '/system/enterprises/'
    | '/system/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forbidden'
    | '/device'
    | '/forgot-password'
    | '/login'
    | '/one-time-token'
    | '/register'
    | '/reset-password'
    | '/verify-email'
    | '/inbox'
    | '/profile'
    | '/set-password'
    | '/settings'
    | '/tenants'
    | '/legal/$documentKey'
    | '/operations/announcements'
    | '/operations/certifications'
    | '/operations/company-types'
    | '/operations/connections'
    | '/operations/country-regions'
    | '/operations/daily-operations'
    | '/operations/feedback'
    | '/operations/imports'
    | '/operations/industries'
    | '/operations/invitation-codes'
    | '/operations/memberships'
    | '/operations/opportunities'
    | '/system/configs'
    | '/system/departments'
    | '/system/files'
    | '/system/legal'
    | '/system/logs'
    | '/system/menus'
    | '/system/positions'
    | '/system/roles'
    | '/system/sms-configs'
    | '/system/storage-disks'
    | '/system/tasks'
    | '/operations/enterprises/$enterpriseId'
    | '/system/dicts/$typeId'
    | '/system/enterprises/$enterpriseId'
    | '/system/monitor/redis'
    | '/system/monitor/service'
    | '/system/monitor/sessions'
    | '/system/users/$userId'
    | '/operations/enterprises'
    | '/system/dicts'
    | '/system/enterprises'
    | '/system/users'
  id:
    | '__root__'
    | '/_auth'
    | '/_authenticated'
    | '/forbidden'
    | '/_auth/device'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/one-time-token'
    | '/_auth/register'
    | '/_auth/reset-password'
    | '/_auth/verify-email'
    | '/_authenticated/inbox'
    | '/_authenticated/profile'
    | '/_authenticated/set-password'
    | '/_authenticated/settings'
    | '/_authenticated/tenants'
    | '/legal/$documentKey'
    | '/_authenticated/'
    | '/_authenticated/operations/announcements'
    | '/_authenticated/operations/certifications'
    | '/_authenticated/operations/company-types'
    | '/_authenticated/operations/connections'
    | '/_authenticated/operations/country-regions'
    | '/_authenticated/operations/daily-operations'
    | '/_authenticated/operations/feedback'
    | '/_authenticated/operations/imports'
    | '/_authenticated/operations/industries'
    | '/_authenticated/operations/invitation-codes'
    | '/_authenticated/operations/memberships'
    | '/_authenticated/operations/opportunities'
    | '/_authenticated/system/configs'
    | '/_authenticated/system/departments'
    | '/_authenticated/system/files'
    | '/_authenticated/system/legal'
    | '/_authenticated/system/logs'
    | '/_authenticated/system/menus'
    | '/_authenticated/system/positions'
    | '/_authenticated/system/roles'
    | '/_authenticated/system/sms-configs'
    | '/_authenticated/system/storage-disks'
    | '/_authenticated/system/tasks'
    | '/_authenticated/operations/enterprises/$enterpriseId'
    | '/_authenticated/system/dicts/$typeId'
    | '/_authenticated/system/enterprises/$enterpriseId'
    | '/_authenticated/system/monitor/redis'
    | '/_authenticated/system/monitor/service'
    | '/_authenticated/system/monitor/sessions'
    | '/_authenticated/system/users/$userId'
    | '/_authenticated/operations/enterprises/'
    | '/_authenticated/system/dicts/'
    | '/_authenticated/system/enterprises/'
    | '/_authenticated/system/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  ForbiddenRoute: typeof ForbiddenRoute
  LegalDocumentKeyRoute: typeof LegalDocumentKeyRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forbidden': {
      id: '/forbidden'
      path: '/forbidden'
      fullPath: '/forbidden'
      preLoaderRoute: typeof ForbiddenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/device': {
      id: '/_auth/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof AuthDeviceRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/one-time-token': {
      id: '/_auth/one-time-token'
      path: '/one-time-token'
      fullPath: '/one-time-token'
      preLoaderRoute: typeof AuthOneTimeTokenRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/inbox': {
      id: '/_authenticated/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof AuthenticatedInboxRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/set-password': {
      id: '/_authenticated/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof AuthenticatedSetPasswordRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/tenants': {
      id: '/_authenticated/tenants'
      path: '/tenants'
      fullPath: '/tenants'
      preLoaderRoute: typeof AuthenticatedTenantsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/legal/$documentKey': {
      id: '/legal/$documentKey'
      path: '/legal/$documentKey'
      fullPath: '/legal/$documentKey'
      preLoaderRoute: typeof LegalDocumentKeyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/operations/announcements': {
      id: '/_authenticated/operations/announcements'
      path: '/operations/announcements'
      fullPath: '/operations/announcements'
      preLoaderRoute: typeof AuthenticatedOperationsAnnouncementsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/certifications': {
      id: '/_authenticated/operations/certifications'
      path: '/operations/certifications'
      fullPath: '/operations/certifications'
      preLoaderRoute: typeof AuthenticatedOperationsCertificationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/company-types': {
      id: '/_authenticated/operations/company-types'
      path: '/operations/company-types'
      fullPath: '/operations/company-types'
      preLoaderRoute: typeof AuthenticatedOperationsCompanyTypesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/connections': {
      id: '/_authenticated/operations/connections'
      path: '/operations/connections'
      fullPath: '/operations/connections'
      preLoaderRoute: typeof AuthenticatedOperationsConnectionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/country-regions': {
      id: '/_authenticated/operations/country-regions'
      path: '/operations/country-regions'
      fullPath: '/operations/country-regions'
      preLoaderRoute: typeof AuthenticatedOperationsCountryRegionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/daily-operations': {
      id: '/_authenticated/operations/daily-operations'
      path: '/operations/daily-operations'
      fullPath: '/operations/daily-operations'
      preLoaderRoute: typeof AuthenticatedOperationsDailyOperationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/feedback': {
      id: '/_authenticated/operations/feedback'
      path: '/operations/feedback'
      fullPath: '/operations/feedback'
      preLoaderRoute: typeof AuthenticatedOperationsFeedbackRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/imports': {
      id: '/_authenticated/operations/imports'
      path: '/operations/imports'
      fullPath: '/operations/imports'
      preLoaderRoute: typeof AuthenticatedOperationsImportsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/industries': {
      id: '/_authenticated/operations/industries'
      path: '/operations/industries'
      fullPath: '/operations/industries'
      preLoaderRoute: typeof AuthenticatedOperationsIndustriesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/invitation-codes': {
      id: '/_authenticated/operations/invitation-codes'
      path: '/operations/invitation-codes'
      fullPath: '/operations/invitation-codes'
      preLoaderRoute: typeof AuthenticatedOperationsInvitationCodesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/memberships': {
      id: '/_authenticated/operations/memberships'
      path: '/operations/memberships'
      fullPath: '/operations/memberships'
      preLoaderRoute: typeof AuthenticatedOperationsMembershipsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/opportunities': {
      id: '/_authenticated/operations/opportunities'
      path: '/operations/opportunities'
      fullPath: '/operations/opportunities'
      preLoaderRoute: typeof AuthenticatedOperationsOpportunitiesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/configs': {
      id: '/_authenticated/system/configs'
      path: '/system/configs'
      fullPath: '/system/configs'
      preLoaderRoute: typeof AuthenticatedSystemConfigsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/departments': {
      id: '/_authenticated/system/departments'
      path: '/system/departments'
      fullPath: '/system/departments'
      preLoaderRoute: typeof AuthenticatedSystemDepartmentsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/files': {
      id: '/_authenticated/system/files'
      path: '/system/files'
      fullPath: '/system/files'
      preLoaderRoute: typeof AuthenticatedSystemFilesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/legal': {
      id: '/_authenticated/system/legal'
      path: '/system/legal'
      fullPath: '/system/legal'
      preLoaderRoute: typeof AuthenticatedSystemLegalRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/logs': {
      id: '/_authenticated/system/logs'
      path: '/system/logs'
      fullPath: '/system/logs'
      preLoaderRoute: typeof AuthenticatedSystemLogsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/menus': {
      id: '/_authenticated/system/menus'
      path: '/system/menus'
      fullPath: '/system/menus'
      preLoaderRoute: typeof AuthenticatedSystemMenusRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/positions': {
      id: '/_authenticated/system/positions'
      path: '/system/positions'
      fullPath: '/system/positions'
      preLoaderRoute: typeof AuthenticatedSystemPositionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/roles': {
      id: '/_authenticated/system/roles'
      path: '/system/roles'
      fullPath: '/system/roles'
      preLoaderRoute: typeof AuthenticatedSystemRolesRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/sms-configs': {
      id: '/_authenticated/system/sms-configs'
      path: '/system/sms-configs'
      fullPath: '/system/sms-configs'
      preLoaderRoute: typeof AuthenticatedSystemSmsConfigsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/storage-disks': {
      id: '/_authenticated/system/storage-disks'
      path: '/system/storage-disks'
      fullPath: '/system/storage-disks'
      preLoaderRoute: typeof AuthenticatedSystemStorageDisksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/tasks': {
      id: '/_authenticated/system/tasks'
      path: '/system/tasks'
      fullPath: '/system/tasks'
      preLoaderRoute: typeof AuthenticatedSystemTasksRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/enterprises/': {
      id: '/_authenticated/operations/enterprises/'
      path: '/operations/enterprises'
      fullPath: '/operations/enterprises/'
      preLoaderRoute: typeof AuthenticatedOperationsEnterprisesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/operations/enterprises/$enterpriseId': {
      id: '/_authenticated/operations/enterprises/$enterpriseId'
      path: '/operations/enterprises/$enterpriseId'
      fullPath: '/operations/enterprises/$enterpriseId'
      preLoaderRoute: typeof AuthenticatedOperationsEnterprisesEnterpriseIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/dicts/': {
      id: '/_authenticated/system/dicts/'
      path: '/system/dicts'
      fullPath: '/system/dicts/'
      preLoaderRoute: typeof AuthenticatedSystemDictsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/dicts/$typeId': {
      id: '/_authenticated/system/dicts/$typeId'
      path: '/system/dicts/$typeId'
      fullPath: '/system/dicts/$typeId'
      preLoaderRoute: typeof AuthenticatedSystemDictsTypeIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/enterprises/': {
      id: '/_authenticated/system/enterprises/'
      path: '/system/enterprises'
      fullPath: '/system/enterprises/'
      preLoaderRoute: typeof AuthenticatedSystemEnterprisesIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/enterprises/$enterpriseId': {
      id: '/_authenticated/system/enterprises/$enterpriseId'
      path: '/system/enterprises/$enterpriseId'
      fullPath: '/system/enterprises/$enterpriseId'
      preLoaderRoute: typeof AuthenticatedSystemEnterprisesEnterpriseIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/monitor/redis': {
      id: '/_authenticated/system/monitor/redis'
      path: '/system/monitor/redis'
      fullPath: '/system/monitor/redis'
      preLoaderRoute: typeof AuthenticatedSystemMonitorRedisRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/monitor/service': {
      id: '/_authenticated/system/monitor/service'
      path: '/system/monitor/service'
      fullPath: '/system/monitor/service'
      preLoaderRoute: typeof AuthenticatedSystemMonitorServiceRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/monitor/sessions': {
      id: '/_authenticated/system/monitor/sessions'
      path: '/system/monitor/sessions'
      fullPath: '/system/monitor/sessions'
      preLoaderRoute: typeof AuthenticatedSystemMonitorSessionsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/users/': {
      id: '/_authenticated/system/users/'
      path: '/system/users'
      fullPath: '/system/users/'
      preLoaderRoute: typeof AuthenticatedSystemUsersIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/system/users/$userId': {
      id: '/_authenticated/system/users/$userId'
      path: '/system/users/$userId'
      fullPath: '/system/users/$userId'
      preLoaderRoute: typeof AuthenticatedSystemUsersUserIdRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
  }
}

interface AuthRouteRouteChildren {
  AuthDeviceRoute: typeof AuthDeviceRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthOneTimeTokenRoute: typeof AuthOneTimeTokenRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthDeviceRoute: AuthDeviceRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthOneTimeTokenRoute: AuthOneTimeTokenRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

interface AuthenticatedRouteRouteChildren {
  AuthenticatedInboxRoute: typeof AuthenticatedInboxRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedSetPasswordRoute: typeof AuthenticatedSetPasswordRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedTenantsRoute: typeof AuthenticatedTenantsRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedOperationsAnnouncementsRoute: typeof AuthenticatedOperationsAnnouncementsRoute
  AuthenticatedOperationsCertificationsRoute: typeof AuthenticatedOperationsCertificationsRoute
  AuthenticatedOperationsCompanyTypesRoute: typeof AuthenticatedOperationsCompanyTypesRoute
  AuthenticatedOperationsConnectionsRoute: typeof AuthenticatedOperationsConnectionsRoute
  AuthenticatedOperationsCountryRegionsRoute: typeof AuthenticatedOperationsCountryRegionsRoute
  AuthenticatedOperationsDailyOperationsRoute: typeof AuthenticatedOperationsDailyOperationsRoute
  AuthenticatedOperationsFeedbackRoute: typeof AuthenticatedOperationsFeedbackRoute
  AuthenticatedOperationsImportsRoute: typeof AuthenticatedOperationsImportsRoute
  AuthenticatedOperationsIndustriesRoute: typeof AuthenticatedOperationsIndustriesRoute
  AuthenticatedOperationsInvitationCodesRoute: typeof AuthenticatedOperationsInvitationCodesRoute
  AuthenticatedOperationsMembershipsRoute: typeof AuthenticatedOperationsMembershipsRoute
  AuthenticatedOperationsOpportunitiesRoute: typeof AuthenticatedOperationsOpportunitiesRoute
  AuthenticatedSystemConfigsRoute: typeof AuthenticatedSystemConfigsRoute
  AuthenticatedSystemDepartmentsRoute: typeof AuthenticatedSystemDepartmentsRoute
  AuthenticatedSystemFilesRoute: typeof AuthenticatedSystemFilesRoute
  AuthenticatedSystemLegalRoute: typeof AuthenticatedSystemLegalRoute
  AuthenticatedSystemLogsRoute: typeof AuthenticatedSystemLogsRoute
  AuthenticatedSystemMenusRoute: typeof AuthenticatedSystemMenusRoute
  AuthenticatedSystemPositionsRoute: typeof AuthenticatedSystemPositionsRoute
  AuthenticatedSystemRolesRoute: typeof AuthenticatedSystemRolesRoute
  AuthenticatedSystemSmsConfigsRoute: typeof AuthenticatedSystemSmsConfigsRoute
  AuthenticatedSystemStorageDisksRoute: typeof AuthenticatedSystemStorageDisksRoute
  AuthenticatedSystemTasksRoute: typeof AuthenticatedSystemTasksRoute
  AuthenticatedOperationsEnterprisesEnterpriseIdRoute: typeof AuthenticatedOperationsEnterprisesEnterpriseIdRoute
  AuthenticatedSystemDictsTypeIdRoute: typeof AuthenticatedSystemDictsTypeIdRoute
  AuthenticatedSystemEnterprisesEnterpriseIdRoute: typeof AuthenticatedSystemEnterprisesEnterpriseIdRoute
  AuthenticatedSystemMonitorRedisRoute: typeof AuthenticatedSystemMonitorRedisRoute
  AuthenticatedSystemMonitorServiceRoute: typeof AuthenticatedSystemMonitorServiceRoute
  AuthenticatedSystemMonitorSessionsRoute: typeof AuthenticatedSystemMonitorSessionsRoute
  AuthenticatedSystemUsersUserIdRoute: typeof AuthenticatedSystemUsersUserIdRoute
  AuthenticatedOperationsEnterprisesIndexRoute: typeof AuthenticatedOperationsEnterprisesIndexRoute
  AuthenticatedSystemDictsIndexRoute: typeof AuthenticatedSystemDictsIndexRoute
  AuthenticatedSystemEnterprisesIndexRoute: typeof AuthenticatedSystemEnterprisesIndexRoute
  AuthenticatedSystemUsersIndexRoute: typeof AuthenticatedSystemUsersIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedInboxRoute: AuthenticatedInboxRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedSetPasswordRoute: AuthenticatedSetPasswordRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedTenantsRoute: AuthenticatedTenantsRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedOperationsAnnouncementsRoute:
    AuthenticatedOperationsAnnouncementsRoute,
  AuthenticatedOperationsCertificationsRoute:
    AuthenticatedOperationsCertificationsRoute,
  AuthenticatedOperationsCompanyTypesRoute:
    AuthenticatedOperationsCompanyTypesRoute,
  AuthenticatedOperationsConnectionsRoute:
    AuthenticatedOperationsConnectionsRoute,
  AuthenticatedOperationsCountryRegionsRoute:
    AuthenticatedOperationsCountryRegionsRoute,
  AuthenticatedOperationsDailyOperationsRoute:
    AuthenticatedOperationsDailyOperationsRoute,
  AuthenticatedOperationsFeedbackRoute: AuthenticatedOperationsFeedbackRoute,
  AuthenticatedOperationsImportsRoute: AuthenticatedOperationsImportsRoute,
  AuthenticatedOperationsIndustriesRoute:
    AuthenticatedOperationsIndustriesRoute,
  AuthenticatedOperationsInvitationCodesRoute:
    AuthenticatedOperationsInvitationCodesRoute,
  AuthenticatedOperationsMembershipsRoute:
    AuthenticatedOperationsMembershipsRoute,
  AuthenticatedOperationsOpportunitiesRoute:
    AuthenticatedOperationsOpportunitiesRoute,
  AuthenticatedSystemConfigsRoute: AuthenticatedSystemConfigsRoute,
  AuthenticatedSystemDepartmentsRoute: AuthenticatedSystemDepartmentsRoute,
  AuthenticatedSystemFilesRoute: AuthenticatedSystemFilesRoute,
  AuthenticatedSystemLegalRoute: AuthenticatedSystemLegalRoute,
  AuthenticatedSystemLogsRoute: AuthenticatedSystemLogsRoute,
  AuthenticatedSystemMenusRoute: AuthenticatedSystemMenusRoute,
  AuthenticatedSystemPositionsRoute: AuthenticatedSystemPositionsRoute,
  AuthenticatedSystemRolesRoute: AuthenticatedSystemRolesRoute,
  AuthenticatedSystemSmsConfigsRoute: AuthenticatedSystemSmsConfigsRoute,
  AuthenticatedSystemStorageDisksRoute: AuthenticatedSystemStorageDisksRoute,
  AuthenticatedSystemTasksRoute: AuthenticatedSystemTasksRoute,
  AuthenticatedOperationsEnterprisesEnterpriseIdRoute:
    AuthenticatedOperationsEnterprisesEnterpriseIdRoute,
  AuthenticatedSystemDictsTypeIdRoute: AuthenticatedSystemDictsTypeIdRoute,
  AuthenticatedSystemEnterprisesEnterpriseIdRoute:
    AuthenticatedSystemEnterprisesEnterpriseIdRoute,
  AuthenticatedSystemMonitorRedisRoute: AuthenticatedSystemMonitorRedisRoute,
  AuthenticatedSystemMonitorServiceRoute:
    AuthenticatedSystemMonitorServiceRoute,
  AuthenticatedSystemMonitorSessionsRoute:
    AuthenticatedSystemMonitorSessionsRoute,
  AuthenticatedSystemUsersUserIdRoute: AuthenticatedSystemUsersUserIdRoute,
  AuthenticatedOperationsEnterprisesIndexRoute:
    AuthenticatedOperationsEnterprisesIndexRoute,
  AuthenticatedSystemDictsIndexRoute: AuthenticatedSystemDictsIndexRoute,
  AuthenticatedSystemEnterprisesIndexRoute:
    AuthenticatedSystemEnterprisesIndexRoute,
  AuthenticatedSystemUsersIndexRoute: AuthenticatedSystemUsersIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRouteRoute: AuthRouteRouteWithChildren,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  ForbiddenRoute: ForbiddenRoute,
  LegalDocumentKeyRoute: LegalDocumentKeyRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
